// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"ExplanationModal_modalContent__2QTQP","modalHeader":"ExplanationModal_modalHeader__3DWwJ","modalTitle":"ExplanationModal_modalTitle__2EZT3"};